import SiteLayout from '@/components/feature/SiteLayout';
import Button from '@/components/base/Button';

export default function NotFound() {
  return (
    <SiteLayout>
      <title>Page Not Found | CLEARY</title>
      <meta name="robots" content="noindex" />
      <section className="px-4 md:px-6 lg:px-20 py-20 md:py-28 lg:py-36">
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-xs md:text-[13px] font-medium tracking-[0.14em] text-secondary-500">ERROR 404</p>
          <h1 className="mt-4 font-heading text-[40px] md:text-[56px] lg:text-[64px] leading-[1.06] font-medium tracking-tight">Page Not Found.</h1>
          <p className="mt-5 text-base md:text-lg leading-[1.6] text-foreground-600">The page you&apos;re looking for may have moved or no longer exists. Let&apos;s get you back somewhere fresh.</p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
            <Button href="/">Back to Home <i className="ri-arrow-right-line" /></Button>
            <Button href="/services" variant="ghost">Explore Services</Button>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}